var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45943 13.5368L8.45945 13.5368L13.5595 5.73675L13.9779 6.01037L13.5595 5.73674C13.635 5.62123 13.6026 5.46628 13.487 5.39069L8.45943 13.5368ZM8.45943 13.5368C8.41945 13.5979 8.35459 13.6386 8.28178 13.6479C8.20928 13.6572 8.13624 13.6342 8.082 13.5849L4.78203 10.5849C4.67987 10.492 4.67234 10.3339 4.76522 10.2318C4.8581 10.1296 5.0162 10.1221 5.11836 10.2149L5.11837 10.215M8.45943 13.5368L5.11837 10.215M5.11837 10.215L7.76751 12.6233L8.20142 13.0177M5.11837 10.215L8.20142 13.0177M8.20142 13.0177L8.52233 12.5269M8.20142 13.0177L8.52233 12.5269M8.52233 12.5269L13.141 5.46313M8.52233 12.5269L13.141 5.46313M13.141 5.46313C13.2165 5.34756 13.3714 5.31515 13.487 5.39069L13.141 5.46313Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2499b6d08d63a86c7e346c22452ea989.svg";
export { ForwardRef as ReactComponent };